// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "346b735eb162e9229e94e660c90f25fd469118f2/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};